import { BsChevronDown } from "react-icons/bs";
import { useState } from "react";

function DropdownFAQ(props) {
  const [active, setActive] = useState(false);

  const handleDropdown = () => {
    setActive(!active);
  };

  return (
    <div>
      <div className="my-4">
        <button
          className="flex items-center justify-between w-full p-6 sm:p-8 text-white text-[16px] lg:text-[20px] rounded-lg text-left bg-gradient-to-br from-adhocBlauw via-adhocBlauw200 to-adhocBlauw200 bg-size-200 bg-pos-0 hover:bg-pos-100 transition-all ease-in-out duration-300"
          onClick={handleDropdown}
        >
          {props.title}
          <span className="float-right pl-6">
            <BsChevronDown
              className={`transition-transform ${ active ? "rotate-180" : ""}`}
              size={25}
            />
          </span>
        </button>

        <div className={active ? "py-4" : "hidden"}>
            <d className="text-[16px] md:text-[18px] leading-8">{props.text}</d>
        </div>
      </div>
    </div>
  );
}

export default DropdownFAQ;
